/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { RefundReason } from './RefundReason';
export type CreateRefundResponse = {
    id: string;
    generation_id?: string;
    reason: RefundReason;
    status: CreateRefundResponse.status;
    created_at: string;
};
export namespace CreateRefundResponse {
    export enum status {
        SUBMITTED = 'submitted',
    }
}

